import { Spin } from "antd";
const Loading = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "50vh",
    }}
  >
    <Spin size="large" />
  </div>
);

export default Loading;
